import { render, staticRenderFns } from "./ConfirmAccountAccessModal.vue?vue&type=template&id=6e7b2deb&scoped=true"
import script from "./ConfirmAccountAccessModal.vue?vue&type=script&lang=js"
export * from "./ConfirmAccountAccessModal.vue?vue&type=script&lang=js"
import style0 from "./ConfirmAccountAccessModal.vue?vue&type=style&index=0&id=6e7b2deb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7b2deb",
  null
  
)

export default component.exports